import { useState, useRef } from 'react'
import { Container, TopLeft, BottomLeft, BottomRight, Hamburger, ScrollWrapper, HeroSection, MenuOverlay, MenuNav, MenuItem, MenuNumber, SubHeading, MenuBackdrop, Section, SectionTitle, SectionSubtitle, ComingSoonSection, ComingSoonText, Footer, FooterLinks, Tag, TrendyGrid, Card, CardTitle, CardText, AvatarImage, AvatarWrapper, SpeechBubble, ThemeSwitchLabel, HiddenCheckbox, KakaoButton, TrendyCard, ReleaseBadge, LockedOverlay, SuggestCard, VideoScrollContainer, VideoCard, VideoFrame, VideoNavContainer, NavButton } from './styles'
import PromptSection from './PromptSection'
import { FaYoutube, FaLock, FaArrowRight, FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import { RiKakaoTalkFill } from 'react-icons/ri'

export default function Overlay({ themeMode, toggleTheme, isMenuOpen, setIsMenuOpen }) {
  const [opacity, setOpacity] = useState(1)

  const handleScroll = (e) => {
    const scrollTop = e.target.scrollTop
    const newOpacity = Math.max(0, 1 - scrollTop / 200)
    setOpacity(newOpacity)
  }

  const scrollToSection = (id) => {
    setIsMenuOpen(false)
    const element = document.getElementById(id)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }
  const videoScrollRef = useRef(null)

  const scrollVideos = (direction) => {
    if (videoScrollRef.current) {
      const container = videoScrollRef.current
      const firstCard = container.querySelector('div')
      if (firstCard) {
        const cardWidth = firstCard.offsetWidth
        const gap = parseInt(window.getComputedStyle(container).gap) || 0
        const scrollAmount = cardWidth + gap
        container.scrollBy({
          left: direction === 'left' ? -scrollAmount : scrollAmount,
          behavior: 'smooth'
        })
      }
    }
  }

  return (
    <Container>
      <MenuBackdrop $isOpen={isMenuOpen} onClick={() => setIsMenuOpen(false)} />
      <MenuOverlay $isOpen={isMenuOpen}>
        <MenuNav>
          <MenuItem onClick={() => scrollToSection('prompts')}>
            <MenuNumber>01</MenuNumber>
            AI Image Prompts
          </MenuItem>
          <MenuItem onClick={() => scrollToSection('trending')}>
            <MenuNumber>02</MenuNumber>
            Trendy Prompts
          </MenuItem>
          <MenuItem onClick={() => scrollToSection('video')}>
            <MenuNumber>03</MenuNumber>
            Video Generation Tips
          </MenuItem>
          <MenuItem onClick={() => scrollToSection('engineering')}>
            <MenuNumber>04</MenuNumber>
            Prompt Engineering
          </MenuItem>
          <MenuItem onClick={() => scrollToSection('showcase')}>
            <MenuNumber>05</MenuNumber>
            Community Showcase
          </MenuItem>
          <MenuItem onClick={() => scrollToSection('about')}>
            <MenuNumber>06</MenuNumber>
            About
          </MenuItem>
        </MenuNav>
      </MenuOverlay>
      <Hamburger onClick={() => setIsMenuOpen(!isMenuOpen)}>
        <div style={{ transform: isMenuOpen ? 'rotate(45deg) translate(5px, 6px)' : 'none' }} />
        <div style={{ opacity: isMenuOpen ? 0 : 1 }} />
        <div style={{ transform: isMenuOpen ? 'rotate(-45deg) translate(5px, -6px)' : 'none' }} />
      </Hamburger>
      <ScrollWrapper onScroll={handleScroll}>
        <HeroSection id="hero">
          <TopLeft>
            <h1>
              NANO
              <ThemeSwitchLabel $isDark={themeMode === 'dark'}>
                <HiddenCheckbox
                  type="checkbox"
                  checked={themeMode === 'dark'}
                  onChange={toggleTheme}
                />
              </ThemeSwitchLabel>
              <br />
              BANANA
              <br />
              PROMPTS
            </h1>
            <SubHeading>
              Nano Banana Pro
              <br />
              Z-Image-Turbo
              <br />
              GPT-4o
              <br />
              Veo 3.1
            </SubHeading>
          </TopLeft>
          <BottomLeft style={{ opacity }}>
            by ssamgpt
            <a href="https://www.youtube.com/@ssamgpt" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', display: 'flex' }}>
              <FaYoutube size="1.5em" style={{ cursor: 'pointer' }} />
            </a>
            <a href="https://open.kakao.com/o/gGB1XWUh" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', display: 'flex' }}>
              <RiKakaoTalkFill size="1.5em" style={{ cursor: 'pointer' }} />
            </a>
          </BottomLeft>
          <BottomRight style={{ opacity }}>
            <span style={{ cursor: 'pointer' }} onClick={() => scrollToSection('prompts')}>AI Image Prompts</span>
            <br />
            <span style={{ cursor: 'pointer' }} onClick={() => scrollToSection('trending')}>Trendy Prompts</span>
            <br />
            <span style={{ cursor: 'pointer' }} onClick={() => scrollToSection('video')}>Video Generation Tips</span>
            <br />
            <span style={{ cursor: 'pointer' }} onClick={() => scrollToSection('engineering')}>Prompt Engineering</span>
            <br />
            <span style={{ cursor: 'pointer' }} onClick={() => scrollToSection('showcase')}>Community Showcase</span>
            <br />
            <span style={{ cursor: 'pointer' }} onClick={() => scrollToSection('about')}>About</span>
          </BottomRight>
        </HeroSection>

        <div id="prompts">
          <PromptSection />
        </div>

        <Section id="trending">
          <SectionTitle>Trendy Prompts</SectionTitle>
          <SectionSubtitle>Real-time trending AI styles and viral generation secrets</SectionSubtitle>
          <TrendyGrid>
            <TrendyCard $isLocked $bg="/prompts/1.png">
              <ReleaseBadge>Next Drop: Mon</ReleaseBadge>
              <LockedOverlay>
                <FaLock size="1.2em" />
                <CardTitle style={{ color: '#fff', fontSize: '1.4rem' }}>Cyberpunk Neon Portrait</CardTitle>
                <CardText style={{ color: 'rgba(255,255,255,0.7)' }}>Unlocks in 2 days</CardText>
              </LockedOverlay>
            </TrendyCard>

            <TrendyCard $isLocked $bg="/prompts/10.png">
              <ReleaseBadge>Weekly Top</ReleaseBadge>
              <LockedOverlay>
                <FaLock size="1.2em" />
                <CardTitle style={{ color: '#fff', fontSize: '1.4rem' }}>Hyper-realistic Food ADS</CardTitle>
                <CardText style={{ color: 'rgba(255,255,255,0.7)' }}>Coming Soon</CardText>
              </LockedOverlay>
            </TrendyCard>

            <SuggestCard onClick={() => window.open('https://open.kakao.com/o/gGB1XWUh', '_blank')}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.8rem', alignItems: 'center' }}>
                <div style={{ padding: '1rem', borderRadius: '50%', background: 'rgba(0,0,0,0.05)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <FaArrowRight size="1.2em" />
                </div>
                <CardTitle style={{ fontSize: '1.5rem', marginBottom: 0 }}>Suggest Next Style</CardTitle>
                <CardText style={{ fontSize: '1rem' }}>카카오톡 커뮤니티에서 원하는 스타일을 제안해 주세요!</CardText>
              </div>
            </SuggestCard>
          </TrendyGrid>
        </Section>

        <Section id="video">
          <SectionTitle>Video Generation Tips</SectionTitle>
          <SectionSubtitle>Master the motion and bring your static images to life</SectionSubtitle>
          <VideoScrollContainer ref={videoScrollRef}>
            {[
              'nfYfkH3PnNQ', 'LR5QrdKM8hE', '8ghpGPOUUJs',
              'DkMf79MJiCY', 'gG_xZ6b4d48', 'yQ6p79HNvjM',
              'Wp_7fAaxVsQ', 'Sah_e9oL3EQ', 'jIy-jU1ofAY'
            ].map((id) => (
              <VideoCard key={id}>
                <VideoFrame
                  src={`https://www.youtube.com/embed/${id}`}
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </VideoCard>
            ))}
          </VideoScrollContainer>
          <VideoNavContainer>
            <NavButton onClick={() => scrollVideos('left')}>
              <FaChevronLeft />
            </NavButton>
            <NavButton onClick={() => scrollVideos('right')}>
              <FaChevronRight />
            </NavButton>
          </VideoNavContainer>
        </Section>

        <Section id="engineering">
          <SectionTitle>Prompt Engineering</SectionTitle>
          <SectionSubtitle>Elevate your interactions with AI and master the art of whispering</SectionSubtitle>
          <ComingSoonSection>
            <ComingSoonText>
              Class & Community <br className="mobile-break" />
              is coming soon
            </ComingSoonText>
            <KakaoButton href="https://open.kakao.com/o/gGB1XWUh" target="_blank" rel="noopener noreferrer">
              <RiKakaoTalkFill />
              카카오톡 커뮤니티 <br className="mobile-break" />
              참여하기
            </KakaoButton>
          </ComingSoonSection>
        </Section>

        <Section id="showcase">
          <SectionTitle>Community Showcase</SectionTitle>
          <ComingSoonSection>
            <ComingSoonText>Coming Soon</ComingSoonText>
            <p style={{ color: 'rgba(0,0,0,0.3)', textAlign: 'center' }}>커뮤니티 여러분의 <br />작품들을 소개하는 공간입니다.</p>
          </ComingSoonSection>
        </Section>

        <Footer id="about">
          <SectionTitle style={{ marginBottom: '2rem' }}>About</SectionTitle>
          <AvatarWrapper>
            <SpeechBubble className="speech-bubble">less is more</SpeechBubble>
            <AvatarImage
              src="/faq-5.png"
              alt="About SSAMGPT"
            />
          </AvatarWrapper>
          <p style={{ color: 'rgba(0,0,0,0.4)', maxWidth: '600px', textAlign: 'center', lineHeight: '1.6', marginBottom: '2rem' }}>
            SSAMGPT는 AI 기술을 먼저 배워서 나눠주는 <br className="mobile-break" />
            1인 개발자 & 커뮤니티입니다.
            <br className="desktop-break" />
            <br className="mobile-break" />
            AI 이미지, 영상, 바이브 코딩에 대해 <br className="mobile-break" />
            함께 공부하며 성장하실 분들을 기다립니다.
          </p>
          <div style={{ fontSize: '1.2rem', fontWeight: 500, marginBottom: '1rem' }}>by ssamgpt</div>
          <FooterLinks>
            <a href="https://www.youtube.com/@ssamgpt" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', display: 'flex' }}>
              <FaYoutube size="2em" style={{ cursor: 'pointer', opacity: 0.6 }} />
            </a>
            <a href="https://open.kakao.com/o/gGB1XWUh" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', display: 'flex' }}>
              <RiKakaoTalkFill size="2em" style={{ cursor: 'pointer', opacity: 0.6 }} />
            </a>
          </FooterLinks>
          <div style={{ marginTop: '1.5rem', fontSize: '0.9rem', opacity: 0.5 }}>
            <a href="mailto:ssamgpt@gmail.com" style={{ color: 'inherit', textDecoration: 'none' }}>ssamgpt@gmail.com</a>
          </div>
          <div style={{ marginTop: '3rem', fontSize: '0.8rem', opacity: 0.3 }}>© 2025 SSAMGPT. All rights reserved.</div>
        </Footer>
      </ScrollWrapper>
    </Container >
  )
}
